<template>
  <div :class="$vuetify.breakpoint.xsOnly ? ' ' : 'px-7 py-7'">
    <v-card class="pb-0 mb-0">
      <v-card-title>
        <v-btn text @click="goBack">
          <v-icon> mdi-arrow-left </v-icon>
        </v-btn>
        <span class="title__class">News</span>
      </v-card-title>
      <v-card-text class="px-3">
        <v-row v-if="loading">
          <v-col cols="12">
            <v-skeleton-loader width="100%" type="card,article"></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row v-else id="newDetailPage">
          <v-col cols="12" :class="$vuetify.breakpoint.smAndUp ? 'px-3' : 'px-0'">
            <div class="img_container__class">
              <img :src="news_detail.image_url" alt="" class="img__class" />
            </div>
          </v-col>
          <v-col cols="12" sm="8" v-if="$vuetify.breakpoint.xsOnly">
            <security-card
              :security="security"
              :growth="news_detail.growth"
            ></security-card>
          </v-col>
          <v-col cols="12" sm="8">
            <news-detail-card
              :news_detail="news_detail"
              :security="security"
            ></news-detail-card>
          </v-col>
          <v-col cols="12" sm="4" v-if="$vuetify.breakpoint.smAndUp">
            <security-card
              :security="security"
              :growth="news_detail.growth"
            ></security-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import apiUrl from "@/common/apiUrl";
import Axios from "@/api/newAxios";
import commonFunctions from "@/common/commonFunctions";
export default {
  name: "NewsDetailPage",
  components: {
    NewsDetailCard: () => import("./NewsDetailCard/NewsDetailCard.vue"),
    SecurityCard: () => import("./SecurityCard/SecurityCard.vue"),
  },
  data() {
    return {
      loading: false,
      security: null,
      news_detail: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    goBack() {
      let query = this.$route.query.query;
      this.$router.push({
        name: "Search",
        params: { query: query },
        query: { tab: 2 },
      });
    },
    getSecurityInfo() {
      this.loading = true;
      const onSuccess = (res) => {
        this.security = res.data;
        // console.log(res.data);
        // this.loading = false;
      };
      const onFailure = (err) => {
        console.error(err);
        this.loading = false;
      };
      const onFinally = () => {
        this.getNewsDetail();
      };
      let params = {};
      if (commonFunctions.getUserId()) {
        params["user_id"] = commonFunctions.getUserId();
      }
      Axios("get", `api/trade/security-info/${this.$route.query.query}`, {
        params,
        onSuccess,
        onFailure,
        onFinally,
        isTokenRequired: false,
      });
    },
    getNewsDetail() {
      const onSuccess = (res) => {
        this.news_detail = res.data.news_data;
        this.loading = false;
      };
      const onFailure = () => {
        this.loading = false;
      };

      let params = {};
      params["id"] = this.$route.query.id;
      params["stock_id"] = this.security.id;
      Axios("get", apiUrl.NEWS_DETIAL, {
        params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
  },
  mounted() {
    this.getSecurityInfo();
  },
};
</script>
<style scoped>
.title__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 27px;

  color: #303030;
}
.img_container__class {
  width: 100%;
}
.img__class {
  width: 100%;
  aspect-ratio: 16 / 6;
  object-fit: fill;
  max-height: 457px;
  border-radius: 10px;
}
@media only screen and (max-width: 600px) {
  .img__class {
    border-radius: 0px;
  }
}
</style>
